import { ADMINS_HAVE_FULL_ACCESS } from "@src/local-features";
import { useSelector } from "@src/store";
import {
  selectedViewAsMode,
  selectedViewAsProductId,
} from "@src/store/slices/appSettings";

export const useAdminHasFullAccess = () => {
  const viewAs = useSelector(selectedViewAsMode);
  const viewAsProductId = useSelector(selectedViewAsProductId);

  if (viewAs && viewAsProductId) {
    return false;
  }

  return ADMINS_HAVE_FULL_ACCESS;
};
